import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { StorageService } from '../core/services/storage.service';
import { LoginService } from '../core/services/login.service';
import { OkCancelDialog } from '../core/dialogs/ok-cancel.dialog/ok-cancel.dialog';
import { MatDialog } from '@angular/material';
import { RegisterService } from '../core/services/register.service';
import { AlertsService } from '../core/services/alerts.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  environment;
  loginForm = new FormGroup({
    username: new FormControl(''),
    password: new FormControl('')
  });

  constructor(
    private router: Router,
    private storageService: StorageService,
    private loginService: LoginService,
    private dialog: MatDialog,
    private registerService: RegisterService,
    private alertService: AlertsService
  ) { }

  ngOnInit(): void {
    this.environment = environment;
  }

  onSubmit(): void {
    this.loginService.login(this.loginForm.value).subscribe((response) => {
      this.storageService.setItem('loggedIn', 'true');
      this.storageService.setItem('user', JSON.stringify(response));
      this.router.navigate(['/map']);
    }, error => {
      if (error.error.exceptionType == "USER_NOT_ACTIVATED") {
        this.openIOkCancelDialog('message.error.USER_NOT_ACTIVATED', 'button.resetToken', '?');
      }
    });
  }

  openIOkCancelDialog(text: string, button: string, buttonValue: string): void {
    const dialogRef = this.dialog.open(OkCancelDialog, {
      width: '600px',
      data: { text: text, button: button, buttonValue: buttonValue },
      panelClass: 'custom-ok-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.registerService.resetToken(this.loginForm.value.username).subscribe(response => {
          this.alertService.sendMessage('success.tokenSend', 'success');
          this.loginForm.reset();
        });
      }
    });
  }
}
